import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'LOGIN_ACCOUNT_RECOVERY_TITLE',
    defaultMessage: 'Kein Zugriff auf die E-Mail Adresse oder Handynummer?',
  },
  description: {
    id: 'LOGIN_ACCOUNT_RECOVERY_DESCRIPTION',
    defaultMessage:
      'Macht nichts: Wir prüfen jetzt Ihre Identität - und dann können Sie eine neue E-mail-Adresse zum Einloggen festlegen.',
  },
  inputLabel: {
    id: 'LOGIN_ACCOUNT_RECOVERY_INPUT_LABEL',
    defaultMessage: 'E-Mail / Handy',
  },
  buttonContinue: {
    id: 'LOGIN_RECOVERY_CONTINUE',
    defaultMessage: 'Weiter',
  },
  invalidCode: {
    id: 'LOGIN_RECOVERY_INVALID_CODE',
    defaultMessage:
      'Leider ist der Code zum zurücksetzen des Passwortes nicht mehr gültig.',
  },
  invalidLink: {
    id: 'LOGIN_RECOVERY_INVALID_LINK',
    defaultMessage:
      'Leider ist der Link zum zurücksetzen des Passwortes nicht mehr gültig.',
  },
  problemsLoginRecoveryIntroduction: {
    id: 'LOGIN_RECOVERY_OTHER_PROBLEMS',
    defaultMessage: 'Andere Probleme beim Einloggen',
  },
  problemsLoginRecoveryLabel: {
    id: 'LOGIN_RECOVERY_OTHER_PROBLEMS_LINK_TEXT',
    defaultMessage: 'Kontaktieren Sie uns',
  },
  forgotCredentialsRecoveryLabel: {
    id: 'LOGIN_RECOVERY_FORGOT_CREDENTIALS',
    defaultMessage: 'E-Mail-Adresse / Hanynummer vergessen?',
  },
});
